import { useEffect, useState, MutableRefObject } from 'react';
import 'intersection-observer';

let intersectionObserver: IntersectionObserver;
const intersectionObserverOptions = {};
const subscribers = new WeakMap();

const handleIntersections = (entries: any[]) => {
  entries.forEach((entry: { target: Record<string, unknown> }) => subscribers.get(entry.target).call(null, entry));
};

const getIntersectionObserver = () => {
  if (!intersectionObserver) {
    intersectionObserver = new IntersectionObserver(
      handleIntersections,
      intersectionObserverOptions,
    );
  }

  return intersectionObserver;
};

const unwatch = (domNode: Element) => {
  intersectionObserver.unobserve(domNode);
  subscribers.delete(domNode);
};

const watch = (
  domNode: Element,
  callback: ({ isIntersecting }: { isIntersecting: boolean }) => void,
) => {
  if (!domNode || subscribers.has(domNode)) {
    return undefined;
  }

  subscribers.set(domNode, callback);
  getIntersectionObserver().observe(domNode);

  return () => unwatch(domNode);
};

function useIsVisible(nodeRef: MutableRefObject<any>) {
  const [isVisible, setVisible] = useState(false);

  function handleVisibilityChange({
    isIntersecting,
  }: {
    isIntersecting: boolean;
  }) {
    setVisible(isIntersecting);
  }

  useEffect(() => watch(nodeRef.current, handleVisibilityChange), [nodeRef]);

  return isVisible;
}

export default useIsVisible;
